import React, { useEffect, useState } from "react";

import ScrollableWrapper from "components/shared/ScollableWrapper";
import {
	skinColors,
	hairColors,
	BodySVGs,
	HairSVGs,
	MiniHairSVGs,
	ClothesSVGs,
} from "./iserbaAvatarIconsMap";

const IserbaAvatarStep = ({ player, onAvatarChosen }) => {
	const [activeTab, setActiveTab] = useState("appearance");
	const [avatar, setAvatar] = useState({
		gender: "male",
		skin_color: skinColors[0],
		hair_shape: "male1",
		hair_color: hairColors[0],
		clothes: "maleCorporate",
	});

	useEffect(() => {
		if (player && player?.avatar && player?.avatar?.gender) {
			setAvatar(player.avatar);
		}
	}, [player]);

	const updateAvatar = (field, value) => {
		setAvatar((prev) => ({ ...prev, [field]: value }));
	};

	const svgHeight = 200;

	const handleAvatarChosen = () => {
		onAvatarChosen(avatar);
	};
	return (
		<div className="flex flex-col items-center w-full h-full min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] overflow-hidden relative">
			<ScrollableWrapper direction="vertical" className="flex-1">
				<div className="p-6 flex flex-col items-center w-full h-full">
					{/* Avatar Renderer */}
					<div className="h-[150px] bg-blue-200 shadow-lg rounded-2xl flex items-center justify-center w-full max-w-[200px]">
						<svg height={svgHeight} viewBox="0 0 150 400">
							{BodySVGs[avatar.gender](avatar.skin_color)}
							{HairSVGs[avatar.gender][avatar.hair_shape](avatar.hair_color)}
							{ClothesSVGs[avatar.gender][avatar.clothes]()}
						</svg>
					</div>

					<div className="mt-4 font-bold text-md w-full flex items-center justify-center bg-gray-100 rounded-full p-2">
						{player?.pseudo}
					</div>

					{/* Customization Options */}
					<div className="w-full max-w-md p-4 bg-gray-100 shadow-lg rounded-2xl mt-4">
						{/* Tabs */}
						<div className="w-full max-w-md flex mb-2">
							<button
								onClick={() => setActiveTab("appearance")}
								className={`flex-1 py-1 px-2 rounded-s-full ${
									activeTab === "appearance"
										? "bg-black text-white"
										: "bg-gray-300"
								}`}
							>
								Apparence
							</button>
							<button
								onClick={() => setActiveTab("clothes")}
								className={`flex-1 py-1 px-2 rounded-e-full ${
									activeTab === "clothes"
										? "bg-black text-white"
										: "bg-gray-300"
								}`}
							>
								Vêtements
							</button>
						</div>
						{activeTab === "appearance" ? (
							<>
								<div>Sexe :</div>
								<div className="flex gap-4 mb-4">
									<button
										onClick={() =>
											updateAvatar("gender", "male") ||
											updateAvatar("hair_shape", "male1") ||
											updateAvatar("clothes", "maleCorporate")
										}
										className={`flex-1 py-1 px-2 rounded-full ${
											avatar.gender === "male"
												? "bg-black text-white scale-110"
												: "bg-gray-300"
										}`}
									>
										Homme
									</button>
									<button
										onClick={() =>
											updateAvatar("gender", "female") ||
											updateAvatar("hair_shape", "female1") ||
											updateAvatar("clothes", "femaleCorporate")
										}
										className={`flex-1 py-1 px-2 rounded-full ${
											avatar.gender === "female"
												? "bg-black text-white scale-110"
												: "bg-gray-300"
										}`}
									>
										Femme
									</button>
								</div>

								<div>Couleur de peau :</div>
								<div className="grid grid-cols-6 gap-2 mb-4">
									{skinColors.map((color) => (
										<button
											key={color}
											className={`w-full aspect-square rounded border ${
												avatar.skin_color === color
													? "border-black scale-110"
													: "border-gray-300"
											}`}
											style={{ backgroundColor: color }}
											onClick={() => updateAvatar("skin_color", color)}
										></button>
									))}
								</div>

								<div>Coupe de cheveux :</div>
								<div className="grid grid-cols-6 gap-2 mb-4">
									{Object.keys(HairSVGs[avatar.gender]).map((hair) => (
										<button
											key={hair}
											className={`border flex items-center justify-center rounded transition-transform ${
												avatar.hair_shape === hair
													? "border-black scale-110"
													: "border-gray-300"
											}`}
											onClick={() => updateAvatar("hair_shape", hair)}
										>
											<div className="w-10 p-1 flex items-center justify-center overflow-hidden aspect-square">
												{MiniHairSVGs[avatar.gender][hair](
													avatar.hair_shape === hair
														? avatar.hair_color
														: "#B0B0B0"
												)}
											</div>
										</button>
									))}
								</div>

								<div>Couleur de cheveux:</div>
								<div className="grid grid-cols-6 gap-2 mb-4">
									{hairColors.map((color) => (
										<button
											key={color}
											className={`w-full aspect-square rounded border ${
												avatar.hair_color === color
													? "border-black scale-110"
													: "border-gray-300"
											}`}
											style={{ backgroundColor: color }}
											onClick={() => updateAvatar("hair_color", color)}
										></button>
									))}
								</div>
							</>
						) : (
							<>
								<div>Tenue :</div>
								<div className="grid grid-cols-4 gap-2 mb-4">
									{Object.keys(ClothesSVGs[avatar.gender]).map((clothes) => (
										<button
											key={clothes}
											className={`py-2 border rounded ${
												avatar.clothes === clothes
													? "border-black scale-105 scale-x-110"
													: "border-gray-300"
											}`}
											onClick={() => updateAvatar("clothes", clothes)}
										>
											<div className="w-full flex items-center justify-center">
												{ClothesSVGs[avatar.gender][clothes]()}
											</div>
										</button>
									))}
								</div>
							</>
						)}
					</div>
					<button
						onClick={handleAvatarChosen}
						className="mt-8 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Valider votre avatar
					</button>
				</div>
			</ScrollableWrapper>
		</div>
	);
};

export default IserbaAvatarStep;
